module.exports = __webpack_public_path__ + "static/media/pipe2_down.7ab5a22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/pipe2_down.png
// module id = 243
// module chunks = 0